<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <div class="mt-5">

        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(0)"
                :link="links[0]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(3)"
                :link="links[3]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-if="linkExists(4)"
            :link="links[4]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <tailwind-image
            v-if="linkExists(5)"
            :link="links[5]"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <div class="mt-5">
            <p>
                Entwurfs- und Realisierungsprojekt „Structures in Exhibition“. Für den Auftritt des Fachbereichs Produktgestaltung auf der internationalen Möbelmesse in Köln IMM wurde von den Studierenden eine raumgreifende Struktur entwickelt, welche die vielschichtigen Themen und Arbeitsgebiete widerspiegelt.
            </p>
            <br>
            <p>Betreuung:</p>
            <p>Markus Holzbach und Knut Völzke</p>
            <p>HfG Offenbach am Main</p>
        </div>
    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                // require( '@/assets/img/pc/hfg_of110122_01k.jpg' ),
                require( '@/assets/img/pc/hfg_of110122_02k.jpg' ),
                require( '@/assets/img/pc/hfg_of110122_03k.jpg' ),
                require( '@/assets/img/pc/hfg_of110122_07k.jpg' ),
                require( '@/assets/img/pc/hfg_of110122_12k.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>